<template>
  <div>
    <el-dialog title="下载二维码" :visible.sync="dialogVisible" width="30%" :close-on-click-modal='false'>
      <el-table :data="tableDataCode" style="width: 100%">
        <el-table-column prop="size" label="二维码尺寸" width="180">
        </el-table-column>
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="downLoad(scope.row)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="upLoad" class="reupload">
        <el-button type="primary" size="small" @click="dialogUpLoad = true">
          重新上传二维码图片
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="小程序二维码" :visible.sync="dialogUpLoad" width="720px">
      <div class="code-content" v-loading="loadFlag">
        <div class="title-tips">当前页面路径过长，请至微信公众平台手动生成二维码</div>
        <div class="title-tips">1、点击下方链接进入微信公众平台，并且登录</div>
        <p class="title-tips a"><a href="https://mp.weixin.qq.com" target="_blank"
            rel="noopener noreferrer">https://mp.weixin.qq.com</a></p>
        <div class="title-tips">2、点击右上方工具》生成小程序码进入页面</div>
        <div class="title-tips">3、复制下面此路径链接，进入此页面，粘贴进入小程序页面路径的输入框中，点击确定即可完成生成</div>
        <div class="title-tips link-flex">
          <p>路径链接</p>
          <div>
            <div class="link-url">{{linkUrl}}</div>
            <el-button type="primary" size="mini" v-clipboard:copy="linkUrl" v-clipboard:success="onCopy"
              v-clipboard:error="onError">复制</el-button>
          </div>
        </div>
        <div class="code-box">
          <p>获取小程序页面小程序码</p>
          <div class="code-input">
            <div class="code-flex">
              <p>小程序名称</p>
              <div>陕西智联医健佳一测试环境</div>
            </div>
            <div class="code-flex">
              <p>小程序页面路径</p>
              <div>
                <div class="input"></div>
                <div>请确保小程序页面路径可被访问。<span>获取更多页面路径</span> </div>
              </div>
            </div>
            <div class="wx-btn">
              <el-button size="mini" disabled>取消</el-button>
              <el-button size="mini" disabled type="primary">确定</el-button>
            </div>
          </div>
        </div>
        <div class="code-down">将二维码上传可供快速下载</div>
        <div class="upload-type-box" v-if="loadImg">
          <img class="load-img" :src="imgPath+loadImg" alt="">
          <img class="link-close" @click="delImg" src="@/assets/images/close.png" alt="">
        </div>
        <el-upload class="upload-type-img" v-else action="/api/dsicm-contact-platform/feign/file/upload"
          :show-file-list="false" :data="{ path: 'dsicm-doctor'}" :on-error='upImgErr' :on-success="upImgSuccess"
          :before-upload="beforeImgUpload" :on-progress='upImg' :headers="headers">
          <i class="el-icon-plus" style="display:block"></i>
        </el-upload>
        <div style="text-align:center">
          <el-button size="mini" type="primary" @click="onSave">确定上传</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { downCode, saveCode } from "../api";
export default {
  props: {
    curRow: {
      type: Object,
      require: true,
      default: () => {}
    }
  },

  data() {
    return {
      loadFlag: false,
      upLoad: false,
      loadImg: "",
      imgPath: process.env.VUE_APP_OSS_URL,
      headers: {
        Authorization: localStorage.getItem("Authorization")
      },
      linkUrl: "",
      dialogVisible: false,
      dialogUpLoad: false,
      tableDataCode: [
        { size: "150*150", val: "150" },
        { size: "256*256", val: "256" },
        { size: "512*512", val: "512" },
        { size: "1024*1024", val: "1024" }
      ]
    };
  },
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },
    showDialogCode() {
      this.upLoad = false;
      this.dialogVisible = true;
    },
    downLoad(row) {
      let parmas = {
        id: this.curRow.id,
        appletId: this.curRow.appletId,
        width: row.val
      };
      downCode(parmas)
        .then(res => {
          if (res.code == 0) {
            let url = process.env.VUE_APP_OSS_URL + res.data;
            console.log(url);
            this.dialogVisible = false;
            this.getUrlBase64(url).then(base64 => {
              let link = document.createElement("a");
              link.href = base64;
              link.download = "qrCode.png";
              link.click();
            });
          } else if (res.code == 500050) {
            this.dialogUpLoad = true;
            this.linkUrl = res.message;
          }
        })
        .catch(err => {});
    },
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        //允许跨域
        img.setAttribute("crossOrigin", "anonymous");
        img.src = url;
        img.onload = function() {
          canvas.height = 300;
          canvas.width = 300;
          ctx.drawImage(img, 0, 0, 300, 300);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    upImg() {
      this.loadTitle = "正在上传，请您耐心等待...";
      this.loadFlag = true;
    },
    upImgErr(err) {
      console.log(err);
      this.loadFlag = false;
    },
    //上传图片
    beforeImgUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt10M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("请上传 PNG、JPG、JPEG格式图片!");
      }
      if (!isLt10M) {
        this.$message.error("图片大小不能超过 3M!");
      }
      return isJPG && isLt10M;
    },
    upImgSuccess(data) {
      this.loadFlag = false;
      if (data.code == 0) {
        this.loadImg = data.data;
      } else {
        this.$message.error(data.message);
      }
    },
    delImg() {
      this.loadImg = "";
    },
    onSave() { 
      if (!this.loadImg) {
        this.$message.error("请上传二维码!");
      } else {
        let parmas = {
          id: this.curRow.id,
          imgPath: this.loadImg
        };
        saveCode(parmas).then(res => {
          if (res.code == 0) {
            this.dialogUpLoad = false;
            this.upLoad = true;
          }
        });
      }
    }
  },
  created() {}
};
</script>
<style scoped lang="less">
.code-content {
  margin: 0 50px;
}
.title-tips,
.code-down {
  margin-bottom: 15px;
  font-size: 12px;
}

.title-tips.a {
  padding-left: 25px;
}
.title-tips a {
  color: #009eff;
}
.link-flex {
  display: flex;
  font-size: 14px;
  color: #333;
  font-weight: bold;
  p {
    width: 60px;
    margin-right: 10px;
  }
  .link-url {
    width: 480px;
    margin-bottom: 10px;
  }
}

.code-box {
  height: 270px;
  background: #f6f8f9;
  padding: 14px 35px 0;
  margin-bottom: 20px;
}
.code-flex {
  display: flex;
  margin-bottom: 15px;
  p {
    margin-right: 10px;
    color: #8d8d8d;
    width: 85px;
  }
  .input {
    width: 280px;
    height: 22px;
    border-radius: 3px;
    border: 1px solid #e6e6e6;
    margin-bottom: 10px;
  }
  span {
    color: #586f9a;
    margin-left: 5px;
  }
}
.code-input {
  background: #fff;
  margin-top: 15px;
  padding: 25px 32px 12px;
  font-size: 12px;
}
.wx-btn {
  text-align: center;
  margin-top: 40px;
}
.wx-btn .el-button--primary {
  background: #a6e0c2;
  color: #c1f0d8;
  border-color: #a6e0c2;
}
.upload-type-box {
  position: relative;
}
.link-close {
  position: absolute;
  left: 71px;
  top: -9px;
  width: 18px;
  cursor: pointer;
}
.load-img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.upload-type-img {
  width: 80px;
  height: 80px;
  border: 1px dashed #e6e6e6;
  font-size: 30px;
  color: #e6e6e6;
  line-height: 80px;
  text-align: center;
  border-radius: 10px;
}
.reupload {
  text-align: center;
  margin-top: 20px;
}
</style>
 